import React, { useState, useContext, useEffect } from "react";
import '../../../../ui-styles/bottomSlider/BottomSlider.css';
import "../../../../ui-styles/bottomSlider/BottomDetailsSlide.css";
import '../../../../lib/ui/imageicon/Styles.css';
import "../../../../ui-styles/list/FormList.css";
import "../../../../ui-styles/buttons/ButtonFilled.css";
import "../../../../ui-styles/buttons/ButtonTxt.css";

import InputField from "../../../../lib/ui/inputs/Input";
import { LangCtx } from "../../../../lib/context";
import TextArea from "../../../../lib/ui/inputs/TextArea";

const AddAllergyInfo = (props) => {
    const { l } = useContext(LangCtx);
    const { error } = props;
    const [drugName, setDrugName] = useState('')
    const [description, setDescription] = useState('')

    useEffect(() => {
        if (props.data) {
            setDrugName(decodeURIComponent(props.data.name));
            setDescription(decodeURIComponent(props.data.description));
        }
    }, [props.data])

    const handleAddDrug = () => {
        let body = {
            name: drugName,
            description: description
        }

        props.addDrug(body);
    }

    const handleditDrug = () => {
        let body = {
            name: drugName,
            description: description
        }

        props.editDrug(props.data.id, body);
    }
    return (
        <div className={props.openAllergy ? "btmDtlSlider visible" : "btmDtlSlider"}>
            <div className="btmDtlPaper">
                <div className="btmDtlHeader">
                    <div className="btmHeaderRow">
                        <span className="hdrTxt">{l.add_allergy}</span>
                        <div className="hdrTxtGroup" onClick={props.closeDrugAlleg}>
                            <span className="hdrBtnTxt">{l.close}</span> </div>
                    </div>
                </div>
                <div className="btmDtlBdy">
                    <div className="colBlock whiteBg borderBtm">
                        {props.errorMsg &&
                            <div className="errorBox">
                                <small className="errorTxt">{props.errorMsg}</small>
                            </div>
                        }
                        <div className="formCol fullWidth">
                            <div className="colBlock nopdng">
                                <form>
                                    <small className="inpLabel">{l.drug_name}:</small>
                                    <InputField
                                        name="drugName"
                                        placeholder={l.drug_name_pc}
                                        type="text"
                                        value={drugName}
                                        error={error && error.drugName}
                                        errorMsg={error.drugName}
                                        maxLength="30"
                                        onChange={(e) => {
                                            error['drugName']='';
                                            setDrugName(e.target.value)}}
                                    />
                                    <small className="inpLabel">{l.desc}</small>
                                    <TextArea
                                        name="Description"
                                        placeholder={l.drug_desc}
                                        type="text"
                                        value={description}
                                        error={error && error.description}
                                        errorMsg={error.description}
                                        maxLength="150"
                                        onChange={(e) => {
                                            error['description']='';
                                            setDescription(e.target.value)}}
                                    />
                                </form>
                            </div>
                        </div>
                        <div className="btnGroup flxEnd pdngVSM">
                            <button className="btnFilled sm ripple" onClick={props.data ? handleditDrug : handleAddDrug}>
                                <span>{props.data ? l.save : l.addbtn}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default AddAllergyInfo;